import { IFRAME_AND_CONTAINER_IDS } from "../../constants";
import { loadIframe } from "../../utils";
import { getIframeSrc } from "./utils";

export const loadSearchComponent = () => {
    const { search } = IFRAME_AND_CONTAINER_IDS;
    const { containerId } = search;
    const container = document.getElementById(containerId);
    if (!container) return;
    const iframeSrc = getIframeSrc();
    loadIframe({
        src: iframeSrc,
        iframeAndContainerIds: search,
    });
};
